import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';

import {DobryAgentBlogTagService} from "../../../../shared/services/dobry-agent-blog-tag.service";
import {AuthService} from "../../../../shared/services/auth.service";
import {Observable, ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {DobryAgentBlogTag} from "../../../../shared/interface/dobry-agent-blog-article";
import {takeUntil} from "rxjs/operators";
import {Router} from "@angular/router";

@Component({
  selector: 'app-da-tag-details-view',
  templateUrl: './da-tag-details-view.component.html',
  styleUrls: ['./da-tag-details-view.component.scss']
})
export class DaTagDetailsViewComponent implements OnInit,OnDestroy {
  @Input() blogTag: Observable<DobryAgentBlogTag>;
  @Output() modifyClicked = new EventEmitter<any>();
  blogTagObject?: DobryAgentBlogTag;
  userPermissions: ReplaySubject<UserPermissions>;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private dobryAgentBlogTagService: DobryAgentBlogTagService,
    private auth: AuthService,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.blogTag
      .pipe(takeUntil(this.destroyed$))
      .subscribe((tag: DobryAgentBlogTag) => {
        this.blogTagObject = tag;
      });

  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  delete(blogTag: DobryAgentBlogTag): void {
    this.dobryAgentBlogTagService
      .confirmDelete(blogTag)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((deleted: boolean) => {
        if (!deleted) {
          return;
        }

        this.router.navigate([
          '/blog-dobry-agent/tagi'
        ]);
      });
  }

  deleteWeak(uuid: string): void {
    this.dobryAgentBlogTagService
      .confirmDeleteWeak(uuid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((deleted: boolean) => {
        if (!deleted) {
          return;
        }

        this.router.navigate([
          '/blog-dobry-agent/tagi'
        ]);
      });
  }

}
